import React from "react";
import CommonSendComponent from "../../components/CommonSendComponent";
import { SEND_CONFIGS } from "../../config/sendConfigs";
import Menu from "../Menu";

const SendMqttSetting = () => {
  return (
    <>
      <Menu />
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <CommonSendComponent config={SEND_CONFIGS.mqttSetting} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SendMqttSetting;
